import React from "react";
import Grid from "@mui/material/Grid";
import {
  isInvalidMultilevelRoseEntry,
  avalancheIconLabels,
} from "../utils/helpers.ts";
import AvalancheIcon from "./AvalancheIcons.tsx";
import MultiLevelRose from "./MultiLevelRose.tsx";

import "../snowreport.css";

type AvalancheTypeKey = keyof typeof avalancheIconLabels | string;

interface AvalancheTypeIconProps {
  type: AvalancheTypeKey;
}

function AvalancheTypeIcon({ type }: AvalancheTypeIconProps) {
  return (
    <div
      style={{ display: "flex", alignItems: "center", fontFamily: "Ubuntu" }}
    >
      <AvalancheIcon avalancheType={type} style={{ height: "30px" }} />
      <span style={{ marginLeft: "10px", fontSize: "16px" }}>
        {(avalancheIconLabels as Record<string, string>)[type as string]}
      </span>
    </div>
  );
}

interface AvalancheConditionEntryProps {
  avalancheConditionData: any;
  avalancheType?: AvalancheTypeKey;
  isFirstEntry?: boolean;
  cssIdentifier: string;
}

export function AvalancheConditionEntry(props: AvalancheConditionEntryProps) {
  if (
    isInvalidMultilevelRoseEntry(props.avalancheConditionData) ||
    !props.avalancheType
  ) {
    return <></>;
  }

  return (
    <>
      {props.isFirstEntry ? null : (
        <Grid size={{ xs: 12 }} style={{ padding: "0px", marginTop: "5px" }}>
          <hr style={{ border: "1px solid black", margin: "0 0 10px 10px" }} />
        </Grid>
      )}

      <div>
        <Grid container>
          <Grid
            size={{ xs: 12, sm: 5 }}
            style={{
              marginBottom: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <AvalancheTypeIcon type={props.avalancheType} />
          </Grid>
          <Grid container size={{ xs: 12, sm: 7 }}>
            <MultiLevelRose
              conditionData={props.avalancheConditionData}
              cssIdentifier={props.cssIdentifier}
              width={"120px"}
              height={"100px"}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default AvalancheConditionEntry;
